import { useNavigate } from 'react-router-dom'

import { useFetchOrderGroups } from './useFetchOrderGroups'
import { useFetchOrders } from './useFetchOrders'

export const useOrdersTable = () => {
  const navigate = useNavigate()

  const { loading, data, pagination, filters, setPage, setPageSize, refresh, formMethods } =
    useFetchOrders()

  const { groups, refresh: refreshGroups } = useFetchOrderGroups()

  const handleRowClick = (id: string) => {
    window.open(`/orders/${id}`, '_blank', 'noopener,noreferrer')
  }

  const handleCreateOrder = () => {
    navigate('/orders/new')
  }

  const refreshAll = async () => {
    await Promise.all([refresh(), refreshGroups()])
  }

  return {
    loading,
    data,
    pagination,
    filters,
    setPage,
    setPageSize,
    refresh: refreshAll,
    groups,
    handleRowClick,
    handleCreateOrder,
    formMethods,
  }
}
